import React from 'react';

const SEGMENTS = [
    { id: 'doctors', label: 'Doctors', icon: 'bi-person-badge' },
    { id: 'appointmentTypes', label: 'Appointment Types', icon: 'bi-calendar-check' },
];

function WebBookingSegmentNav({ activeSegment, onSegmentChange }) {
    return (
        <div className="web-booking-segment" role="tablist" aria-label="Web booking sections">
            {SEGMENTS.map((segment) => (
                <button
                    key={segment.id}
                    type="button"
                    role="tab"
                    aria-selected={activeSegment === segment.id}
                    className={`web-booking-segment__item ${activeSegment === segment.id ? 'is-active' : ''}`}
                    onClick={() => onSegmentChange(segment.id)}
                >
                    <i className={`bi ${segment.icon} me-1`}></i>
                    {segment.label}
                </button>
            ))}
        </div>
    );
}

export default WebBookingSegmentNav;
